import Papa from 'papaparse';

class DataSetManager {
  constructor() {
    this.rawData = [];
    this.data = [];
    this.categories = [];
  }

  async loadCsvList(onComplete) {
    const list = ['/street-gallery/assets/artworks.csv'];
    let nLoaded = 0;
    const onListLoaded = async () => {
      nLoaded++;
      if (nLoaded === list.length) {
        this.data.forEach((item) => {
          item.hasCategory = this.hasCategory(item);
        });

        onComplete();
      }
    };

    list.forEach((filename) => {
      this.loadCsv(onListLoaded, filename, this.data);
    });
  }

  loadCsv(
    onComplete,
    filename = '/street-gallery/assets/all-SDG.csv',
    data = null,
  ) {
    if (!data) {
      data = this.data;
      this.data = [];
    }

    Papa.parse(window.location.protocol + window.location.host + filename, {
      download: true,
      worker: true,
      header: true,
      step: (results) => {
        /*
        const yearRow = results.data.year || results.data.date_created;

        if (yearRow) {
          const year = yearRow.substring(0, 4);
          results.data.year = year === 'null' ? 1950 : parseInt(year);
        }
        */

        results.data.landscape =
          parseInt(results.data.image_width) >
          parseInt(results.data.image_height);

        // remove parenthesis
        results.data.creator = results.data.creator.replace(
          / *\([^)]*\) */g,
          '',
        );

        results.data.title = results.data.title.replace(/ *\([^)]*\) */g, '');
        results.data.image_url = results.data.image_url.replace(
          /^http:\/\//i,
          'https://',
        );

        results.data.partner_logo = results.data.partner_logo.replace(
          /^http:\/\//i,
          'https://',
        );

        this.sanitize(results.data, 'title');
        this.sanitize(results.data, 'creator');
        this.sanitize(results.data, 'city');
        this.sanitize(results.data, 'partner_logo');
        this.sanitize(results.data, 'exhibition');

        const collections = ['The Future is Unwritten', '#TheWorldWeWant'];
        if (collections.includes(results.data.exhibition)) {
          results.data.collection_title = results.data.exhibition;
        }

        // remove commas
        results.data.creator = results.data.creator.split(',')[0];
        this.data.push(results.data);

        this.getCategories(results.meta);
      },
      complete: () => {
        onComplete();

        /*
        this.rawData.reduceRight((acc, item, index, object) => {
          if (!this.hasCategory(item)) {
            object.splice(index, 1);
          }
        }, []);
        this.downloadCsv();
        */

        this.data = this.randomize([...this.data]);
      },
    });
  }

  downloadCsv() {
    var csv = Papa.unparse(this.rawData);
    var csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    var csvURL = window.URL.createObjectURL(csvData);
    var testLink = document.createElement('a');
    testLink.href = csvURL;
    testLink.setAttribute('test', 'test.csv');
    testLink.click();
  }

  hasCategory(item) {
    let hasCat = false;
    this.categories.forEach((cat) => {
      if (item[cat.key] && item[cat.key].toLowerCase() === 'true') {
        hasCat = true;
        return hasCat;
      }
    });

    return hasCat;
  }

  getCategories(meta) {
    for (let i = 15; i < meta.fields.length; i++) {
      const item = meta.fields[i];
      if (!this.categories.some((e) => e.key === item)) {
        this.categories.push({ key: item, value: item });
      }
    }

    this.categories = this.categories.sort((a, b) =>
      a.key.localeCompare(b.key),
    );
  }

  sanitize(data, key) {
    if (data[key] === 'null') {
      data[key] = '';
    }
  }

  getItemById(id) {
    return this.data.find((i) => i.asset_id === id);
  }

  getItemsByIds(list) {
    let result = [];
    list.forEach((id) => {
      const item = this.getItemById(id);
      if (item) {
        result.push(item);
      }
    });
    return result;
  }

  async filterByCategories(data, categories) {
    return new Promise((resolve) => {
      const filtered = data.filter((item, index) => {
        let hasCategory = false;
        const isCurated = item.exhibition === '#TheWorldWeWant';
        const hasCategorySelected = !categories || categories.length === 0;

        if (isCurated && !hasCategorySelected) {
        }

        if (!categories || categories.length === 0) {
          hasCategory = false;
          return false;
        }

        /*
        if (!item.hasCategory || !isCurated) {
          hasCategory = false; 
          return false;
        }
        */

        if (categories && categories.length >= 0) {
          categories.forEach((cat) => {
            if (item[cat] && item[cat].toLowerCase() === 'true') {
              hasCategory = true;
              return true;
            }
          });
        }
        return hasCategory;
      });
      resolve(filtered);
    });
  }

  async filterByLandscape(data, ratioFilter) {
    return new Promise((resolve) => {
      const filtered = data.filter((item, index) => {
        if (item.landscape && ratioFilter.landscape) return true;
        if (!item.landscape && ratioFilter.portrait) return true;
        return false;
      });
      resolve(filtered);
    });
  }

  async filterByCurated(data, curated) {
    return new Promise((resolve) => {
      const filtered = data.filter((item) => {
        if (curated) {
          if (item.exhibition === '#TheWorldWeWant') return true;
        } else {
          return true;
        }
        return false;
      });
      resolve(filtered);
    });
  }

  async filterByCollection(data, exhibition) {
    return new Promise((resolve) => {
      const filtered = data.filter((item) => {
        if (item.exhibition === exhibition) {
          return true;
        } else {
          return false;
        }
      });
      resolve(filtered);
    });
  }

  async filterByCollections(data, exhibitions) {
    return new Promise((resolve) => {
      const filtered = data.filter((item) => {
        if (exhibitions.length === 0) return true;
        return exhibitions.includes(item.exhibition);
      });
      resolve(filtered);
    });
  }

  async filter(data, min, max, maxResults = 600) {
    data = this.randomize(data);
    return new Promise((resolve) => {
      let total = 0;
      const filtered = data.filter((item, index) => {
        let comp = item.year >= min && item.year <= max;
        if (comp) total++;
        comp = total <= maxResults ? comp : false;
        return comp;
      });
      resolve(filtered);
    });
  }

  async filterByColorSimilarity(data, index) {
    data = this.randomize(data);

    return new Promise((resolve) => {
      const filtered = data.filter((item) => {
        if (index === -1) return true;
        if (item.similarities) return item.similarities.includes(index);
        return false;
      });
      resolve(filtered);
    });
  }

  randomize(data) {
    for (let i = data.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * i);
      const temp = data[i];
      data[i] = data[j];
      data[j] = temp;
    }
    return data;
  }
}
export default DataSetManager;
